import React, { useState } from 'react'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'
import {
  Dialog,
  DialogCloseButton,
  DialogContent,
  DialogHeader,
  DialogOverlay,
} from '@wartek-id/dialog-v1'

import IconBg from 'app/GNNPage/components/IconBg'

type MitraCardProps = {
  fullDescription: string
  icon?: React.ReactNode
  fullName: string
  name: string
  shortDescription: string
  url?: string
}

const MitraCard = ({
  fullDescription,
  fullName,
  icon,
  name,
  shortDescription,
  url,
}: MitraCardProps) => {
  const [show, setShow] = useState(false)
  return (
    <>
      <div className="bg-gray-5 p-6 rounded-lg border shadow-sm hover:shadow-md transition-shadow flex flex-col h-full">
        <div className="flex flex-col items-center text-center flex-grow">
          <div className="w-16 h-16 mb-4 p-1 rounded-lg overflow-hidden bg-white border">
            {icon ?? (
              <IconBg className="bg-blue-10">
                <Icon color="informational">domain</Icon>
              </IconBg>
            )}
          </div>
          <Text className="mb-3" variant="body-bold" as="h3">
            {name}
          </Text>
          <Text className="mb-1 flex-grow" variant="body-sm" color="subdued">
            {shortDescription}
          </Text>
          <div className="flex flex-col gap-3 w-full">
            <Button
              fullWidth
              size="sm"
              className="underline"
              variant="ghost"
              color="black"
              onClick={() => {
                setShow(true)
              }}
            >
              Selengkapnya
            </Button>
            {url && (
              <Button
                fullWidth
                size="sm"
                color="white"
                onClick={() => {
                  window.open(url, '_blank')?.focus()
                }}
              >
                Kunjungi Situs
                <Icon fontSize="sm" className="ml-1">
                  open_in_new
                </Icon>
              </Button>
            )}
          </div>
        </div>
      </div>

      <Dialog
        size="lg"
        type="modal"
        isOpen={show}
        onClose={() => {
          setShow(false)
        }}
      >
        <DialogOverlay />
        <DialogContent>
          <DialogHeader>
            <Text as="h2" variant="display-sm">
              {name}
            </Text>
          </DialogHeader>
          <div className="p-6 space-y-2">
            <div className="flex gap-3 mb-5">
              {icon ?? (
                <IconBg className="bg-blue-10">
                  <Icon color="informational">domain</Icon>
                </IconBg>
              )}
              <div className="flex flex-col justify-center gap-3">
                <Text as="h2" variant="heading-lg">
                  {fullName}
                </Text>
                {url && (
                  <Button
                    onClick={() => {
                      window.open(url, '_blank')?.focus()
                    }}
                    size="sm"
                    color="white"
                    className="!w-fit"
                  >
                    Kunjungi Situs
                    <Icon fontSize="sm" className="ml-1" color="informational">
                      open_in_new
                    </Icon>
                  </Button>
                )}
              </div>
            </div>
            <Text variant="body-lg" className="!font-bold">
              Deskripsi
            </Text>
            <Text>{fullDescription}</Text>
          </div>
          <DialogCloseButton />
        </DialogContent>
      </Dialog>
    </>
  )
}

export default MitraCard
